import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    button: {
        '& .MuiIconButton-root': {
            color: theme.palette.text.main
        }
    }
}));